import { Component, Input, inject } from '@angular/core';
import { NzDrawerService } from "ng-zorro-antd/drawer";
import { ProcessHistoryComponent } from "@app/_shared/components/process-history/process-history.component";
import { CommonModule } from '@angular/common';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';


@Component({
    selector: 'app-show-process-history-button',
    template: `
    <button nz-button nzType="link"
            nz-tooltip nzTooltipTitle="Показать историю процесса"
            (click)="showProcessHistory()">
      <i nz-icon nzType="clock-circle-o"></i>
    </button>
  `,
    imports: [
        CommonModule,
        NzButtonModule,
        NzToolTipModule,
        NzIconModule,
    ]
})
export class ShowProcessHistoryButtonComponent {
  private drawerService = inject(NzDrawerService);


  @Input()
  taskId? : string;

  @Input()
  historic = false;

  showProcessHistory(): void {
    if (this.taskId) {
      const drawerRef = this.drawerService.create<ProcessHistoryComponent, { id: string }, string>({
        nzTitle: 'Просмотр истории процесса',
        nzContent: ProcessHistoryComponent,
        nzWidth: 500,
        nzContentParams: {
          taskId: this.taskId,
          historic: this.historic,
        }
      });
      drawerRef.afterOpen.subscribe(() => {
        console.log('ProcessHistoryComponent open');
      });
      drawerRef.afterClose.subscribe(data => {
        console.log(data);
        if (typeof data === 'string') {
          // this.value = data;
        }
      });
    }
  }
}
